import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { Container, Card, Button, Alert, Spinner } from "react-bootstrap";

const KycDetails = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // ------------------------------------- API -------------------------------------
  const details = ApiHook.CallKycDetails();
  const kycIdenfyMutation = ApiHook.CallKycIdenfy();

  // ------------------------------- Functionalities -------------------------------
  const [userKyc, setUserKyc] = useState(details?.data?.userKyc);

  useEffect(() => {
    setUserKyc(details?.data?.userKyc);
  }, [details]);

  const handleKycApply = () => {
    kycIdenfyMutation.mutate(null, {
      onSuccess: (res) => {
        if (res?.status) {
          console.log(res, "response from kycIdenfyMutation");
          queryClient.invalidateQueries({ queryKey: ["kyc-details"] });
          toast.success(t("kyc_application_successful"));
        } else {
          toast.error(t(res?.description ?? "Something went wrong"));
        }
      },
    });
  };

  return (
    <>
      <style>
        {`
          .kyc-details-container {
            min-height: 100vh;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 80px;
            padding-top: 60px;
            padding-bottom: 40px;
            box-sizing: border-box;
          }
          .kyc-card {
            border-radius: 15px;
            background: #1e1e2f;
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
            width: 600px;
            height: 400px;
            text-align: center;
            padding: 40px;
            color: #ffffff;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .page-head-top {
            font-size: 2.5rem;
            font-weight: 700;
            color: #d1d1e0;
            margin-bottom: 40px;
            text-transform: uppercase;
          }
          .kyc-btn {
            border-radius: 10px;
            padding: 15px 35px;
            font-weight: 700;
            background-color: #4a90e2;
            border: none;
            color: #fff;
            text-decoration: none;
            transition: background-color 0.3s ease, transform 0.2s ease;
            width: 250px;
            font-size: 1.2rem;
          }
          .kyc-btn:hover {
            background-color: #357abd;
            transform: scale(1.05);
          }
          .animated-alert {
            border-radius: 10px;
            font-size: 1.1rem;
            animation: fadeIn 0.5s ease-in;
            margin-bottom: 20px;
            background-color: #2a2a3d;
            color: #d1d1e0;
            padding: 15px;
          }
          .kyc-verified {
            font-size: 1.5rem;
            color: #28a745;
            font-weight: 600;
            margin-bottom: 20px;
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <Container className="kyc-details-container">
        <Card className="kyc-card">
          <Card.Body>
            <h2 className="page-head-top">{t("kyc_details")}</h2>

            {details?.data?.kycVerified ? (
              <div className="kyc-verified">{t("kyc_verified")}</div>
            ) : (
              <>
                {details?.data?.walletAddress === null &&
                  !details?.data?.kycApplied === 1 && (
                    <Alert variant="info" className="animated-alert">
                      {details?.data?.notificationMessage}
                    </Alert>
                  )}
                {details?.data?.kycApplied === 1 && details?.data?.kycUrl ? (
                  <div>
                    <a
                      href={details?.data?.kycUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="kyc-btn"
                    >
                      {t("open_kyc_verification")}
                    </a>
                  </div>
                ) : (
                  details?.data?.kycApplied === 0 && (
                    <div>
                      <Button
                        variant="primary"
                        size="lg"
                        className="kyc-btn"
                        onClick={handleKycApply}
                        disabled={kycIdenfyMutation.isLoading}
                      >
                        {kycIdenfyMutation.isLoading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-2"
                            />
                            {t("loading")}
                          </>
                        ) : (
                          t("apply_for_kyc")
                        )}
                      </Button>
                    </div>
                  )
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default KycDetails;
